import React from 'react'
import classnames from 'classnames'

export function ButtonSection (props) {
  return (<div className={classnames('button-section', props.className)}>{props.children}</div>)
}

export function ButtonGroupCustom (props) {
  return <div className='button-group-custom'>{props.children}</div>
}



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.ButtonSection.js